import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { DietSearchedFoodModel } from 'src/app/core/model/object/diet-model';
import { ActivatedRoute } from '@angular/router';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AddFoodBottomsheetComponent } from '../add-food-bottomsheet/add-food-bottomsheet.component';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { Subject } from 'rxjs';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import { captureMessage } from '@sentry/angular';

@Component({
  selector: 'app-add-food',
  templateUrl: './add-food.component.html',
  styleUrls: ['./add-food.component.scss'],
})
export class AddFoodComponent implements OnInit {
  searchText: string;
  searchedFoods: DietSearchedFoodModel[];
  dietId: string;
  day: string;
  meal: string;

  showLoading = false;
  histories: FoodModel[] = null;

  txtQueryChanged: Subject<string> = new Subject<string>();
  isEmpty: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private planService: PlanService,
    private snackBarService: SnackBarService,
    private matBottomSheet: MatBottomSheet,
    private diaryAnalytics: DiaryAnalyticsService,
    private textHelper: TextHelper
  ) {
    this.day = this.route.snapshot.paramMap.get('day');
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.meal = this.route.snapshot.paramMap.get('meal');
    this.searchedFoods = [];
    this.txtQueryChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((model) => {
        this.searchText = model;
        this.searchQ(model);
      });
  }

  ngOnInit() {
    this.diaryAnalytics.analyticDiaryPackageSearchFoodVisited();
    this.histories = this.planService.getHistory();
  }

  back() {
    this.planService.goBack();
  }
  search(query: string) {
    query = query.trim();
    if (query.length <= 0) {
      this.isEmpty = false;
      this.searchText = '';
      this.searchedFoods = [];
    } else {
      this.txtQueryChanged.next(query);
    }
  }
  searchQ(text: string) {
    if (this.searchText && this.searchText !== '') {
      this.showLoading = true;
      this.isEmpty = false;
      this.planService
        .findFood(
          this.textHelper.replaceArabicLettersWithPersian(this.searchText)
        )
        .then((res) => {
          if (text === this.searchText) {
            this.searchedFoods = [];
            if (res.isSuccess()) {
              this.searchedFoods = res.getData().getSearchedFoods();
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
          }
          this.showLoading = false;
          if (this.searchedFoods.length <= 0) {
            this.isEmpty = true;
          }
        })
        .catch((err) => {
          console.log(err);
          captureMessage('Error at Get search food data - 96 - add-food');
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        });
    } else {
      this.searchedFoods = [];
      this.histories = this.planService.getHistory();
    }
  }

  clearSearchText() {
    this.isEmpty = false;
    this.histories = this.planService.getHistory();
    this.searchText = '';
  }

  async foodDetail(id: string) {
    this.showLoading = true;
    const food = await this.planService.getFoodDeatailByDb(id);
    if (food) {
      this.planService.addTohistory(food);
      this.showLoading = false;
      this.matBottomSheet.open(AddFoodBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
        data: {
          food: food,
          dietId: this.dietId,
          day: this.day,
          meal: this.meal,
        },
      });
    } else {
      captureMessage('Error at Get search food data - 127 - add-food');

      this.snackBarService.showSnackBar('خطا در دریافت اطلاعات از سرور');
    }

    this.showLoading = false;
  }
  removeFoodLog(f: FoodModel) {
    this.planService.removeHistory(f);
    this.histories = this.planService.getHistory();
  }
}
